(function(){
  'use strict';

  if (!theme.storeSelectorData) {
    return;
  }

  const wasLandingStoreSelectorShown = Cookies.get('landing-store-selector');
  const wasStoreSelectorShown = Cookies.get('store-selector-shown');
  
  const storeSelectorTriggers = document.querySelectorAll('.store-selector__trigger');
  const storeSelectorModal = document.querySelector('.store-selector__modal');
  const languageSelector = document.querySelector('.language-selector__trigger');
  const hasLanguageSelector = languageSelector !== null;
  
  if (!storeSelectorModal) {
    return;
  }

  if (storeSelectorTriggers && storeSelectorTriggers.length > 0) {
    storeSelectorTriggers.forEach((trigger) => {
      const dropdownSelect = trigger.querySelector('.store-selector__dropdown-select');
      if (dropdownSelect) {
        dropdownSelect.addEventListener('change', function(e) {
          const selectedStore = this.value;
          handleStoreSelection(selectedStore, trigger);
        });
      }
    });
  }
  
  function handleStoreSelection(selectedStore, trigger) {
    const storesMap = {
      'us': 'https://sweedbeauty.com/',
      'gb': 'https://sweedbeauty.com/en-gb',
      'eu': 'https://sweedbeauty.eu',
      'global': 'https://sweedbeauty.global',
      'de': 'https://sweedbeauty.com/de-de',
      'nl': 'https://sweedbeauty.com/nl-nl',
      'it': 'https://sweedbeauty.com/it-it',
      'se': 'https://sweedbeauty.se/',
    };

    const languageRedirects = {
      'de': {
        'de': 'https://sweedbeauty.com/de-de',
        'en': 'https://sweedbeauty.com/en-de'
      },
      'nl': {
        'nl': 'https://sweedbeauty.com/nl-nl',
        'en': 'https://sweedbeauty.com/en-nl'
      },
      'it': {
        'it': 'https://sweedbeauty.com/it-it',
        'en': 'https://sweedbeauty.com/en-it'
      }
    };
    
    let redirectUrl = storesMap[selectedStore];
    
    const globalMatch = selectedStore.match(/^global-(.+)$/);
    if (globalMatch) {
      const countryCode = globalMatch[1];
      

      const euCountries = ['AD', 'AL', 'AM', 'AX', 'BA', 'BE', 'BG', 'BY', 'CH', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FO', 'FI', 'FR', 'GE', 'GI', 'GL', 'GP', 'GR', 'GG', 'HU', 'IS', 'IE', 'LV', 'LT', 'MK', 'MT', 'YT', 'MD', 'MC', 'ME', 'NL', 'NO', 'PL', 'PT', 'RE', 'RO', 'SI', 'SJ', 'SK', 'SM', 'ES', 'TR', 'UA', 'VA'];
      
      if (countryCode === 'US') {
        redirectUrl = storesMap['us'] || 'https://sweedbeauty.com/';
      } else if (countryCode === 'GB') {
        redirectUrl = storesMap['gb'] || 'https://sweedbeauty.com/en-gb';
      } else if (countryCode === 'NL') {
        redirectUrl = languageRedirects['nl']['nl'] || 'https://sweedbeauty.com/nl-nl';
      } else if (countryCode === 'DE') {
        redirectUrl = languageRedirects['de']['de'] || 'https://sweedbeauty.com/de-de';
      } else if (countryCode === 'IT') {
        redirectUrl = languageRedirects['it']['it'] || 'https://sweedbeauty.com/it-it';
      } else if (euCountries.includes(countryCode)) {
        redirectUrl = storesMap['eu'] || 'https://sweedbeauty.eu';
      } else {
        redirectUrl = storesMap['global'] || 'https://sweedbeauty.global';
      }
    } else {
      const combinedMatch = selectedStore.match(/^(de|nl|it)-(de|nl|it|en)$/);
      if (combinedMatch) {
        const country = combinedMatch[1];
        const language = combinedMatch[2];
        
        if (languageRedirects[country] && languageRedirects[country][language]) {
          redirectUrl = languageRedirects[country][language];
        }
      } else {
        const storesWithLanguage = ['de', 'nl', 'it'];
        if (storesWithLanguage.includes(selectedStore)) {
          const primaryLanguage = selectedStore; 
          if (languageRedirects[selectedStore] && languageRedirects[selectedStore][primaryLanguage]) {
            redirectUrl = languageRedirects[selectedStore][primaryLanguage];
          }
        }
      }
    }

    const currentPath = window.location.pathname;
    const productMatch = currentPath.match(/\/products\/([^\/\?]+)/);
    
    if (productMatch && productMatch[1]) {
      const productHandle = productMatch[1];
      const baseUrl = redirectUrl.replace(/\/$/, '');
      redirectUrl = `${baseUrl}/products/${productHandle}`;
      
      if (window.location.search) {
        redirectUrl += window.location.search;
      }
      if (window.location.hash) {
        redirectUrl += window.location.hash;
      }
    }

    if (window.__isLandingStoreSelectorEnabled) {
      Cookies.set('landing-store-selector', true, { expires: 365 });
    }
    Cookies.set('selected-store-selector', selectedStore, { expires: 365 });
    Cookies.set('store-selector-shown', true, { expires: 365 });

    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      console.error('No redirect URL found for store:', selectedStore);
    }
  }

  function closeStoreSelectorModal() {
    storeSelectorModal.classList.remove('store-selector__modal--open');
    const currentMarketValue = storeSelectorSelect ? storeSelectorSelect.value : null;
    if (currentMarketValue) {
      Cookies.set('selected-store-selector', currentMarketValue, { expires: 365 });
    }
    Cookies.set('store-selector-shown', true, { expires: 365 });
  }

  const storeSelectorModalInner = storeSelectorModal.querySelector('.store-selector__modal__inner');
  if (storeSelectorModalInner) {
    storeSelectorModalInner.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  storeSelectorModal.addEventListener('click', (e) => {
    if (e.target === storeSelectorModal) {
      closeStoreSelectorModal();
    }
  });

  const closeButton = storeSelectorModal.querySelector('.store-selector__close');
  if (closeButton) {
    closeButton.addEventListener('click', closeStoreSelectorModal);
  }

  const $storeSelectorHeadline = storeSelectorModal.querySelector('.store-selector__modal__title');
  const $storeSelectorSelectorLabel = storeSelectorModal.querySelector('.store-selector__selector-label');
  const $storeSelectorDescription = storeSelectorModal.querySelector('.store-selector__description-text');
  const $storeSelectorCurrencyLabel = storeSelectorModal.querySelector('.store-selector__currency-label');
  const $storeSelectorChangeStoreButton = storeSelectorModal.querySelector('.store-selector__change-store-button');
  
  const $storeSelectorPaymentMethodsInternational = storeSelectorModal.querySelector('.store-selector__payment-methods-international');
  const $storeSelectorPaymentMethodsSwedish = storeSelectorModal.querySelector('.store-selector__payment-methods-swedish');
  
  const storeSelectorSelect = storeSelectorModal.querySelector('.store-selector__select');
  const $storeSelectorPopupTrigger = storeSelectorModal.querySelector('.store-selector__popup-trigger');
  const $storeSelectorPopupText = storeSelectorModal.querySelector('.store-selector__popup-text');
  const storeLanguageSelectNl = storeSelectorModal.querySelector('.store-selector__language-select.nl-language');
  const storeLanguageSelectDe = storeSelectorModal.querySelector('.store-selector__language-select.de-language');
  const storeLanguageSelectIt = storeSelectorModal.querySelector('.store-selector__language-select.it-language');

  if (!storeSelectorSelect || !$storeSelectorChangeStoreButton) {
    return;
  }

  const storesMap = {
    'us': 'https://sweedbeauty.com/',
    'gb': 'https://sweedbeauty.com/en-gb',
    'eu': 'https://sweedbeauty.eu',
    'global': 'https://sweedbeauty.global',
    'de': 'https://sweedbeauty.com/de-de',
    'nl': 'https://sweedbeauty.com/nl-nl',
    'it': 'https://sweedbeauty.com/it-it',
    'se': 'https://sweedbeauty.se/',
  };

  const languageRedirects = {
    'de': {
      'de': 'https://sweedbeauty.com/de-de',
      'en': 'https://sweedbeauty.com/en-de'
    },
    'nl': {
      'nl': 'https://sweedbeauty.com/nl-nl',
      'en': 'https://sweedbeauty.com/en-nl'
    },
    'it': {
      'it': 'https://sweedbeauty.com/it-it',
      'en': 'https://sweedbeauty.com/en-it'
    }
  };

  const savedStore = Cookies.get('selected-store-selector');
  const hasSavedStorePreference = savedStore && savedStore !== '';
  
  let actualSelectedStore = null;
  if (hasSavedStorePreference && storeSelectorSelect.querySelector(`option[value="${savedStore}"]`)) {
    actualSelectedStore = savedStore;
  } else {
    const selectedOption = storeSelectorSelect.querySelector('option[selected]');
    if (selectedOption && selectedOption.value) {
      actualSelectedStore = selectedOption.value;
    }
  }

  let selectedStore = '';
  
  function showChangeCountryPlaceholder() {
    if (storeSelectorSelect) {
      storeSelectorSelect.value = '';
    }
    if ($storeSelectorPopupTrigger) {
      $storeSelectorPopupTrigger.classList.remove('store-selector__popup-trigger--selected');
    }
    if ($storeSelectorPopupText) {
      $storeSelectorPopupText.textContent = 'Change country';
    }
    selectedStore = '';
  }
  
  if (storeSelectorSelect) {
    storeSelectorSelect.value = '';
  }
  if ($storeSelectorPopupText) {
    $storeSelectorPopupText.textContent = 'Change country';
  }
  if ($storeSelectorPopupTrigger) {
    $storeSelectorPopupTrigger.classList.remove('store-selector__popup-trigger--selected');
  }
  
  function restoreActualSelection() {
    if (actualSelectedStore && storeSelectorSelect) {
      const option = storeSelectorSelect.querySelector(`option[value="${actualSelectedStore}"]`);
      if (option) {
        storeSelectorSelect.value = actualSelectedStore;
        selectedStore = actualSelectedStore;
        updatePopupTriggerText();
      }
    }
  }

  const storeToCountryMap = {
    'us': 'United States',
    'gb': 'United Kingdom',
    'eu': 'Europe',
    'global': 'ROW',
    'de': 'Germany',
    'nl': 'Netherlands',
    'it': 'Italy',
    'se': 'Sweden'
  };

  function updatePopupTriggerText() {
    if (!$storeSelectorPopupText || !$storeSelectorPopupTrigger) {
      return;
    }
    
    if (!selectedStore || selectedStore === '') {
      $storeSelectorPopupTrigger.classList.remove('store-selector__popup-trigger--selected');
      $storeSelectorPopupText.textContent = 'Change country';
      return;
    }
    
    const selectedOption = storeSelectorSelect.querySelector(`option[value="${selectedStore}"]`);
    if (selectedOption) {
      const optionText = selectedOption.textContent.trim();
      if (optionText && !optionText.includes('──') && optionText !== 'Popular' && optionText !== 'Global') {
        $storeSelectorPopupText.textContent = optionText;
        $storeSelectorPopupTrigger.classList.add('store-selector__popup-trigger--selected');
      } else {
        $storeSelectorPopupTrigger.classList.remove('store-selector__popup-trigger--selected');
        $storeSelectorPopupText.textContent = 'Change country';
      }
    }
  }

  function updateStoreSelectorText() {
    if (!selectedStore || selectedStore === '') {
      return;
    }
    
    let storeIdentifier = selectedStore;
    let countryName = storeToCountryMap[selectedStore] || selectedStore;
    let countryCode = null;
    
    const globalMatch = selectedStore.match(/^global-(.+)$/);
    if (globalMatch) {
      countryCode = globalMatch[1];

      const euCountries = ['AD', 'AL', 'AM', 'AX', 'BA', 'BE', 'BG', 'BY', 'CH', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FO', 'FI', 'FR', 'GE', 'GI', 'GL', 'GP', 'GR', 'GG', 'HU', 'IS', 'IE', 'LV', 'LT', 'MK', 'MT', 'YT', 'MD', 'MC', 'ME', 'NL', 'NO', 'PL', 'PT', 'RE', 'RO', 'SI', 'SJ', 'SK', 'SM', 'ES', 'TR', 'UA', 'VA'];
      
      if (countryCode === 'US') {
        storeIdentifier = 'us';
        countryName = 'United States';
      } else if (countryCode === 'GB') {
        storeIdentifier = 'gb';
        countryName = 'United Kingdom';
      } else if (countryCode === 'NL') {
        storeIdentifier = 'nl';
        countryName = 'Netherlands';
      } else if (countryCode === 'DE') {
        storeIdentifier = 'de';
        countryName = 'Germany';
      } else if (countryCode === 'IT') {
        storeIdentifier = 'it';
        countryName = 'Italy';
      } else if (euCountries.includes(countryCode)) {
        storeIdentifier = 'eu';
        countryName = countryCode;
      } else {
        storeIdentifier = 'global';
        countryName = countryCode;
      }
      
      const selectedOption = storeSelectorSelect.querySelector(`option[value="${selectedStore}"]`);
      if (selectedOption) {
        const optionText = selectedOption.textContent.trim();
        const nameMatch = optionText.match(/^(.+?)\s*\(/);
        if (nameMatch) {
          countryName = nameMatch[1].trim();
        }
      }
    } else {
      const combinedMatch = selectedStore.match(/^(de|nl|it)-(de|nl|it|en)$/);
      if (combinedMatch) {
        storeIdentifier = combinedMatch[1];
        countryName = storeToCountryMap[storeIdentifier] || storeIdentifier;
      } else {

        const storeIdentifierMap = {
          'us': 'us',
          'gb': 'gb',
          'eu': 'eu',
          'global': 'global',
          'de': 'de',
          'nl': 'nl',
          'it': 'it',
          'se': 'se'
        };
        storeIdentifier = storeIdentifierMap[selectedStore] || selectedStore;
        countryName = storeToCountryMap[selectedStore] || selectedStore;
      }
    }
    
    const storeData = theme.storeSelectorData.dictionaries.find((dictionary) => {
      return dictionary.id.toLowerCase() === storeIdentifier.toLowerCase();
    });

    if (!storeData) {
      console.warn('Store data not found for:', storeIdentifier);
      return;
    }

    if ($storeSelectorHeadline) {
      let titleText = storeData.modalTitle;
      if (!titleText || titleText.trim() === '') {
        titleText = `Welcome we ship to {COUNTRY}.`;
      }
      
      titleText = titleText.replace(/{COUNTRY}/g, countryName);
      
      $storeSelectorHeadline.innerHTML = `<span id="detected-country-name">${titleText}</span>`;
    }
    if ($storeSelectorSelectorLabel) $storeSelectorSelectorLabel.textContent = storeData.selectLabel;
    
    if ($storeSelectorDescription) {
      if (countryCode) {
        const exceptionCountries = ['BA', 'BY', 'AL', 'SM', 'XK', 'IS'];
        if (exceptionCountries.includes(countryCode)) {
          $storeSelectorDescription.style.display = 'none';
        } else {
          $storeSelectorDescription.style.display = '';
          $storeSelectorDescription.innerHTML = storeData.description.replace(/\n/g, "<br />");
        }
      } else {
        $storeSelectorDescription.style.display = '';
        $storeSelectorDescription.innerHTML = storeData.description.replace(/\n/g, "<br />");
      }
    }
    
    if ($storeSelectorCurrencyLabel) $storeSelectorCurrencyLabel.textContent = storeData.currencyLabel;
    
    if ($storeSelectorChangeStoreButton) {
      let buttonText = storeData.changeStoreButton || '';
      buttonText = buttonText.replace(/{COUNTRY}/g, countryName);
      $storeSelectorChangeStoreButton.textContent = buttonText;
    }

    if ($storeSelectorPaymentMethodsInternational) {
      $storeSelectorPaymentMethodsInternational.classList.toggle('hide', selectedStore === 'se');
    }
    if ($storeSelectorPaymentMethodsSwedish) {
      $storeSelectorPaymentMethodsSwedish.classList.toggle('hide', selectedStore !== 'se');
    }

    if (storeLanguageSelectNl) storeLanguageSelectNl.classList.add('hide');
    if (storeLanguageSelectDe) storeLanguageSelectDe.classList.add('hide');
    if (storeLanguageSelectIt) storeLanguageSelectIt.classList.add('hide');
  }

  let isFirstChange = true;
  let isIPDetectionChange = false;
  
  storeSelectorSelect.addEventListener('change', (e) => {
    const newValue = e.target.value;
    
    if (!newValue || newValue === '') {
      restoreActualSelection();
      return;
    }
    
    selectedStore = newValue;
    actualSelectedStore = newValue; 
    

    if (!isIPDetectionChange) {
      updatePopupTriggerText();
    }
        isIPDetectionChange = false;
    
    if (!isFirstChange) {
      Cookies.set('selected-store-selector', selectedStore, { expires: 365 });
    }
    isFirstChange = false;
    
    updateStoreSelectorText();
  });

  let ipDetectionHasSetSelection = false;
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (storeSelectorModal.classList.contains('store-selector__modal--open')) {
          if (!ipDetectionHasSetSelection && !selectedStore) {
            showChangeCountryPlaceholder();
          }
        }
      }
    });
  });
  
  observer.observe(storeSelectorModal, {
    attributes: true,
    attributeFilter: ['class']
  });
  
  if (storeSelectorModal.classList.contains('store-selector__modal--open') && !selectedStore) {
    showChangeCountryPlaceholder();
  }

  $storeSelectorChangeStoreButton.addEventListener('click', () => {
    if (!selectedStore || selectedStore === '') {
      return;
    }
    
    let redirectUrl = storesMap[selectedStore];
    
    const globalMatch = selectedStore.match(/^global-(.+)$/);
    if (globalMatch) {
      const countryCode = globalMatch[1];
      
      const euCountries = ['AD', 'AL', 'AM', 'AX', 'BA', 'BE', 'BG', 'BY', 'CH', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FO', 'FI', 'FR', 'GE', 'GI', 'GL', 'GP', 'GR', 'GG', 'HU', 'IS', 'IE', 'LV', 'LT', 'MK', 'MT', 'YT', 'MD', 'MC', 'ME', 'NL', 'NO', 'PL', 'PT', 'RE', 'RO', 'SI', 'SJ', 'SK', 'SM', 'ES', 'TR', 'UA', 'VA'];
      
      if (countryCode === 'US') {
        redirectUrl = storesMap['us'] || 'https://sweedbeauty.com/';
      } else if (countryCode === 'GB') {
        redirectUrl = storesMap['gb'] || 'https://sweedbeauty.com/en-gb';
      } else if (countryCode === 'NL') {
        redirectUrl = languageRedirects['nl']['nl'] || 'https://sweedbeauty.com/nl-nl';
      } else if (countryCode === 'DE') {
        redirectUrl = languageRedirects['de']['de'] || 'https://sweedbeauty.com/de-de';
      } else if (countryCode === 'IT') {
        redirectUrl = languageRedirects['it']['it'] || 'https://sweedbeauty.com/it-it';
      } else if (euCountries.includes(countryCode)) {
        redirectUrl = storesMap['eu'] || 'https://sweedbeauty.eu';
      } else {
        redirectUrl = storesMap['global'] || 'https://sweedbeauty.global';
      }
    } else {
      const combinedMatch = selectedStore.match(/^(de|nl|it)-(de|nl|it|en)$/);
      if (combinedMatch) {
        const country = combinedMatch[1];
        const language = combinedMatch[2];
        
        if (languageRedirects[country] && languageRedirects[country][language]) {
          redirectUrl = languageRedirects[country][language];
        }
      } else {
        const storesWithLanguage = ['de', 'nl', 'it'];
        if (storesWithLanguage.includes(selectedStore)) {
          const primaryLanguage = selectedStore; 
          if (languageRedirects[selectedStore] && languageRedirects[selectedStore][primaryLanguage]) {
            redirectUrl = languageRedirects[selectedStore][primaryLanguage];
          }
        }
      }
    }

    const currentPath = window.location.pathname;
    const productMatch = currentPath.match(/\/products\/([^\/\?]+)/);
    
    if (productMatch && productMatch[1]) {
      const productHandle = productMatch[1];
      const baseUrl = redirectUrl.replace(/\/$/, '');
      redirectUrl = `${baseUrl}/products/${productHandle}`;
      
      if (window.location.search) {
        redirectUrl += window.location.search;
      }
      if (window.location.hash) {
        redirectUrl += window.location.hash;
      }
    }

    if (window.__isLandingStoreSelectorEnabled) {
      Cookies.set('landing-store-selector', true, { expires: 365 });
    }
    Cookies.set('selected-store-selector', selectedStore, { expires: 365 });
    Cookies.set('store-selector-shown', true, { expires: 365 });

    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      console.error('No redirect URL found for store:', selectedStore);
    }
  });

  if (window.__isLandingStoreSelectorEnabled && !wasLandingStoreSelectorShown && !savedStore) {
    storeSelectorModal.classList.add('store-selector__modal--open', 'store-selector__landing-layer');
  }

  const currentMarketHandle = theme.storeSelectorData ? theme.storeSelectorData.currentMarketHandle : null;
  
  const marketHandleMap = {
    'us': 'us',
    'gb': 'gb',
    'eu': 'eu',
    'international': 'global',
    'global': 'global',
    'de': 'de',
    'nl': 'nl',
    'it': 'it',
    'se': 'se',
    '': 'us',
    null: 'us'
  };
  const normalizedCurrentMarket = marketHandleMap[currentMarketHandle] || currentMarketHandle || 'us';

  const countryToMarketMap = {
    'US': 'us',
    'GB': 'gb',
    'NL': 'nl',
    'DE': 'de',
    'IT': 'it',
    'SE': 'se',
    'AD': 'eu', 'AL': 'eu', 'AM': 'eu', 'AT': 'eu', 'AX': 'eu', 'BA': 'eu', 'BE': 'eu', 'BG': 'eu', 'BY': 'eu', 'CH': 'eu', 'HR': 'eu', 'CY': 'eu', 'CZ': 'eu',
    'DK': 'eu', 'EE': 'eu', 'FO': 'eu', 'FI': 'eu', 'FR': 'eu', 'GE': 'eu', 'GI': 'eu', 'GL': 'eu', 'GP': 'eu', 'GR': 'eu', 'GG': 'eu', 'HU': 'eu',
    'IS': 'eu', 'IE': 'eu', 'LV': 'eu', 'LT': 'eu', 'LU': 'eu', 'MK': 'eu', 'MT': 'eu', 'YT': 'eu', 'MD': 'eu', 'MC': 'eu', 'ME': 'eu', 'NO': 'eu', 'PL': 'eu',
    'PT': 'eu', 'RE': 'eu', 'RO': 'eu', 'SI': 'eu', 'SJ': 'eu', 'SK': 'eu', 'SM': 'eu', 'ES': 'eu', 'TR': 'eu', 'UA': 'eu', 'VA': 'eu'
  };

  function updateIPDetectedCountry(detectedCountryName, detectedMarket, currencyCode, shouldShowModal, detectedCountryCode) {
    const titleEl = storeSelectorModal.querySelector('.store-selector__modal__title');
    
    const exceptionCountries = ['BA', 'BY', 'AL', 'SM', 'XK', 'IS'];
    const isExceptionCountry = exceptionCountries.includes(detectedCountryCode);
    
    const storeIdentifierForData = (detectedMarket === 'eu') ? 'eu' : detectedMarket;
    
    const storeData = theme.storeSelectorData.dictionaries.find((dictionary) => {
      return dictionary.id.toLowerCase() === storeIdentifierForData.toLowerCase();
    });
    
    if (titleEl && detectedMarket && storeData) {
      let titleText = storeData.modalTitle;
      if (!titleText || titleText.trim() === '') {
        titleText = `Welcome we ship to {COUNTRY}.`;
      }
      titleText = titleText.replace(/{COUNTRY}/g, detectedCountryName);
      titleEl.innerHTML = `<span id="detected-country-name">${titleText}</span>`;
    }
    
    if ($storeSelectorDescription) {
      if (isExceptionCountry) {
        $storeSelectorDescription.style.display = 'none';
      } else {
        $storeSelectorDescription.style.display = '';
        if (storeData) {
          $storeSelectorDescription.innerHTML = storeData.description.replace(/\n/g, "<br />");
        }
      }
    }
    
    if ($storeSelectorChangeStoreButton && storeData) {
      let buttonText = storeData.changeStoreButton || '';
      buttonText = buttonText.replace(/{COUNTRY}/g, detectedCountryName);
      $storeSelectorChangeStoreButton.textContent = buttonText;
    }

    if (storeSelectorSelect && detectedMarket) {
      let optionValueToSelect = detectedMarket;
      
      if (detectedMarket === 'nl') {
        optionValueToSelect = 'global-NL';
      } else if (detectedMarket === 'de') {
        optionValueToSelect = 'de-de';
      } else if (detectedMarket === 'it') {
        optionValueToSelect = 'it-it';
      }
      
      const optionToSelect = storeSelectorSelect.querySelector(`option[value="${optionValueToSelect}"]`);
      if (optionToSelect) {
        selectedStore = optionValueToSelect;
        actualSelectedStore = optionValueToSelect;
        ipDetectionHasSetSelection = true;
        storeSelectorSelect.value = optionValueToSelect;
        isIPDetectionChange = true;
        const changeEvent = new Event('change', { bubbles: true });
        storeSelectorSelect.dispatchEvent(changeEvent);
      }
    }


    console.log('Popup show check:', {
      shouldShowModal: shouldShowModal,
      wasStoreSelectorShown: wasStoreSelectorShown,
      willShow: shouldShowModal 
    });
    
    if (shouldShowModal) {
      console.log('Showing popup modal');
      storeSelectorModal.classList.add('store-selector__modal--open');
    } else {
      console.log('Not showing popup - markets match');
    }
  }

  console.log('IP Detection Check:', {
    hasSavedStorePreference: hasSavedStorePreference,
    savedStore: savedStore,
    currentMarketHandle: currentMarketHandle,
    normalizedCurrentMarket: normalizedCurrentMarket
  });
  
  if (hasSavedStorePreference) {
    console.log('Skipping IP detection - user has saved preference:', savedStore);
    const titleEl = storeSelectorModal.querySelector('.store-selector__modal__title');
    if (titleEl && savedStore) {
      const storeIdentifier = savedStore;
      const storeData = theme.storeSelectorData.dictionaries.find((dictionary) => {
        return dictionary.id.toLowerCase() === storeIdentifier.toLowerCase();
      });
      
      const savedCountryName = storeToCountryMap[savedStore] || savedStore;
      let titleText = storeData?.modalTitle;
      if (!titleText || titleText.trim() === '') {
        titleText = `Welcome we ship to {COUNTRY}!`;
      }
      titleText = titleText.replace(/{COUNTRY}/g, savedCountryName);
      titleEl.innerHTML = `<span id="detected-country-name">${titleText}</span>`;
    }
  } else {
    console.log('Running IP detection - no saved preference');
    if (storeSelectorSelect) {
    fetch('https://geolocation-db.com/json/')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        if (data.country_code && data.country_name) {
          const detectedCountryCode = data.country_code;
          const detectedCountryName = data.country_name;
          const detectedMarket = countryToMarketMap[detectedCountryCode] || 'global';
          const currencyCode = 'USD';

          const marketsMatch = detectedMarket === normalizedCurrentMarket;
          const shouldShowModal = !marketsMatch;
          updateIPDetectedCountry(detectedCountryName, detectedMarket, currencyCode, shouldShowModal, detectedCountryCode);
        } else {
          throw new Error('Invalid response data');
        }
      })
      .catch(error => {
        console.log('geolocation-db.com failed, trying alternative API:', error);
        const script = document.createElement('script');
        script.src = 'https://ip-api.com/json/?callback=handleIPDetection';
        window.handleIPDetection = function(data) {
          if (data.countryCode && data.country) {
            const detectedCountryCode = data.countryCode;
            const detectedCountryName = data.country;
            const detectedMarket = countryToMarketMap[detectedCountryCode] || 'global';
            const currencyCode = data.currency || 'USD';

            const marketsMatch = detectedMarket === normalizedCurrentMarket;
            const shouldShowModal = !marketsMatch;

            console.log('IP Detection Debug (ip-api.com JSONP):', {
              detectedCountry: detectedCountryName,
              detectedMarket: detectedMarket,
              currentMarket: normalizedCurrentMarket,
              marketsMatch: marketsMatch,
              shouldShowModal: shouldShowModal,
              wasStoreSelectorShown: wasStoreSelectorShown,
              hasSavedPreference: hasSavedStorePreference
            });

            updateIPDetectedCountry(detectedCountryName, detectedMarket, currencyCode, shouldShowModal, detectedCountryCode);
            
            delete window.handleIPDetection;
            document.head.removeChild(script);
          } else {
            console.log('JSONP API returned invalid data');
            document.head.removeChild(script);
            delete window.handleIPDetection;
          }
        };
        document.head.appendChild(script);
        
        setTimeout(() => {
          if (window.handleIPDetection) {
            console.log('JSONP timeout, trying final fallback');
            document.head.removeChild(script);
            delete window.handleIPDetection;
            
            const script2 = document.createElement('script');
            script2.src = 'https://ipinfo.io/json?callback=handleIPInfo';
            window.handleIPInfo = function(data) {
              if (data.country && data.country.length === 2) {
                const detectedCountryCode = data.country;
                const detectedMarket = countryToMarketMap[detectedCountryCode] || 'global';
                const currencyCode = 'USD';

                const marketsMatch = detectedMarket === normalizedCurrentMarket;
                const shouldShowModal = !marketsMatch;

                const countryName = storeToCountryMap[detectedMarket] || detectedCountryCode;

                console.log('IP Detection Debug (ipinfo.io JSONP):', {
                  detectedCountry: countryName,
                  detectedMarket: detectedMarket,
                  currentMarket: normalizedCurrentMarket,
                  marketsMatch: marketsMatch,
                  shouldShowModal: shouldShowModal,
                  wasStoreSelectorShown: wasStoreSelectorShown,
                  hasSavedPreference: hasSavedStorePreference
                });

                updateIPDetectedCountry(countryName, detectedMarket, currencyCode, shouldShowModal, detectedCountryCode);
              }
              delete window.handleIPInfo;
              document.head.removeChild(script2);
            };
            document.head.appendChild(script2);
          }
        }, 5000);
      });
    }
  } 
})();